// import React from "react";
// import { TbTargetArrow } from "react-icons/tb";
// import { GiStairsGoal } from "react-icons/gi";
// import { FaHandshake } from "react-icons/fa";
// import { motion } from "framer-motion";

// const points = [
//   "Herbal, Plant-Based Formulations",
//   "Veterinary-Approved, Research-Backed",
//   "Certified Manufacturing Excellence",
//   "Full-Service OEM & Private Label Solutions",
//   "Global Export Expertise",
//   "Sustainable & Ethical Commitment",
//   "Dedicated B2B Partnership Support",
// ];

// const brandPoints = [
//   "Nature-Powered Formulas: Plant-based, safe, and free from harsh chemicals—because true wellness begins in nature.",
//   "Vet-Crafted. Lab-Certified. Pet-Approved.: Backed by veterinarians and tested for safety, efficacy, and flavor.",
//   "Your Brand, Our Expertise: Custom formulations, private labeling, and eye-catching packaging that brings your vision to life.",
//   "Global-Ready Manufacturing: Export-grade standards with flexible MOQs, fast lead times, and multilingual labeling.",
//   "Eco-Conscious from Start to Finish: Sustainable packaging, ethical sourcing, and a strict no-animal-testing policy.",
//   "Partners, Not Just Providers: Personalized support, responsive communication, and long-term business commitment.",
// ];

// const AboutUs: React.FC = () => {
//   return (
//     <div className="w-full flex flex-col items-center px-4 sm:px-8 md:px-16">
//       {/* About Us Section */}
//       <div className="bg-[#f98715] p-8 w-full mb-10">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-white text-center mb-6">
//           About Us
//         </h2>
//         <div className="flex flex-col md:flex-row items-center justify-center space-x-6">
//           <div className="w-40 h-40 bg-white rounded-full shadow-lg overflow-hidden mb-4 md:mb-0">
//             <img
//               src="https://th.bing.com/th/id/OIP.7uBrI-yBrE6iqZpnWDxUgAHaG0?rs=1&pid=ImgDetMain"
//               alt="Company Logo"
//               className="w-full h-full object-cover"
//             />
//           </div>
//           <p className="text-white text-sm lg:text-lg leading-relaxed md:w-2/3 lg:text-center md:text-left text-justify px-1">
//             At <strong>Adins International Pvt. Ltd.</strong>, we believe true
//             pet care begins with nature, love, and responsibility. Our mission
//             is to craft herbal, plant-based supplements that support your pet’s
//             health safely—without chemicals or animal-derived ingredients.
//             Rooted in Ayurveda and enhanced by modern science, our vet-approved
//             formulas target immunity, digestion, skin, joints, and emotional
//             wellness. Every product is 100% vegan, cruelty-free, and ethically
//             sourced. We never test on animals and stand for compassionate,
//             sustainable care. With Adins, you’re not just choosing
//             supplements—you’re joining a movement for conscious, holistic pet
//             wellness. Because pets aren’t just companions—they’re family.
//           </p>
//         </div>
//       </div>

//       {/* Our Product Range Section */}
//       <div className="p-8 w-full mb-10">
//         <h2 className="text-4xl md:text-5xl font-bold mb-10">
//           Our{" "}
//           <span className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#322e88] via-[#f98715] to-purple-600">
//             Product
//           </span>{" "}
//           Range
//         </h2>

//         <p className="text-md mt-5 text-gray-800 leading-relaxed mb-6">
//           Adins International Pvt. Ltd. offers a variety of herbal, vegan, and
//           cruelty-free pet wellness products, expertly formulated for dogs and
//           cats. Our range includes: <br />
//           ✅ Herbal Pet Supplements: Immunity boosters, digestive enzymes, joint
//           support, skin care, and calming drops. <br />
//           ✅ Pet Treats & Snacks: Vegan treats, dental chews, and protein-rich
//           biscuits. <br />
//           ✅ Complete Vegan Pet Food: 100% vegetarian meals and special diets.
//           <br />
//           ✅ Himalayan Yak Milk Chews: Long-lasting, preservative-free.
//           <br />
//           ✅ Natural Catnip Products: Engaging catnip toys.
//           <br />✅ Eco-Friendly Cat Litter: Herbal and clay-based options.
//         </p>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           <div className="bg-blue-50 p-6 rounded-lg shadow-lg">
//             <h3 className="text-xl font-semibold text-blue-500 mb-4">
//               Pet Herbal Foods
//             </h3>
//             <p className="text-gray-700 text-sm text-justify">
//               We offer a comprehensive range of herbal, vegan, and cruelty-free
//               pet wellness products designed to support the complete health and
//               happiness of dogs and cats. Each product is carefully formulated
//               by veterinary experts and crafted using time-tested Ayurvedic
//               ingredients combined with modern scientific practices.
//             </p>
//           </div>
//           <div className="bg-yellow-50 p-6 rounded-lg shadow-lg">
//             <h3 className="text-xl font-semibold text-yellow-600 mb-4">
//               Packaging Essentials
//             </h3>
//             <p className="text-gray-700 text-sm text-justify">
//               At Adins International Pvt. Ltd., we provide premium, customizable
//               packaging to protect product quality and reflect your brand.
//               Choose from stand-up pouches, jars, bottles, sachets, and bulk
//               bags in various sizes. Options include BPA-free food-grade layers,
//               eco-friendly materials, and resealable closures. Custom branding,
//               multilingual labels, and QR codes are available. Packaging is
//               designed for 18–24 months of shelf life and optimized for storage
//               and shipping with reinforced master cartons.
//             </p>
//           </div>
//           <div className="bg-purple-50 p-6 rounded-lg shadow-lg">
//             <h3 className="text-xl font-semibold text-purple-600 mb-4">
//               Customized Printing
//             </h3>
//             <p className="text-gray-700 text-sm text-justify">
//               At Adins International Pvt. Ltd., we offer tailored printing and
//               labeling services to build your brand identity. Choose from
//               digital, flexographic, gravure, or UV printing with waterproof,
//               scratch-resistant finishes. Customize labels with your logo,
//               product info, QR codes, and multilingual text. We support private
//               labeling, unique die cuts, and compliant designs for jars,
//               pouches, and bottles. Our in-house team offers design assistance
//               and mockups to ensure quality and accuracy. Elevate your packaging
//               with premium, market-ready solutions designed to protect and
//               promote your product.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Sustainability at Our Core Section */}
//       <div className="p-8 lg:px-8 py-1 w-full mb-10">
//         <h2 className="text-3xl font-bold text-green-600 mb-6">
//           Sustainability <span className="text-black">at Our Core</span>
//         </h2>
//         <div className="flex flex-col md:flex-row items-center space-x-6">
//           <div className="w-32 h-32 bg-white rounded-full shadow-lg overflow-hidden mb-4 md:mb-0">
//             <img
//               src="https://norpakltd.com/img/containers/assets/environmental-world.jpg/9e1c97fa4fc8877159ec6c963abd46b3.jpg"
//               alt="Sustainability Icon"
//               className="w-full h-full object-cover"
//             />
//           </div>
//           <p className="text-gray-700 lg:text-lg text-md px-1 text-justify leading-relaxed w-full lg:text-left md:text-left">
//             At Adins International Pvt. Ltd., sustainability is at the heart of
//             everything we do. Our 100% plant-based, cruelty-free formulas use
//             responsibly sourced herbs and exclude harsh chemicals. We follow
//             eco-friendly manufacturing with low waste, energy-efficient, and
//             non-toxic processes. Packaging options include biodegradable,
//             compostable, and recyclable materials like kraft bags and
//             refill-friendly bottles. Our logistics focus on reduced carbon
//             footprint through optimized shipping and lightweight packaging. As a
//             globally responsible brand, we align with UN Sustainable Development
//             Goals and ethical supply chains. Partner with Adins—for high-quality
//             pet care that’s better for pets, and better for the planet.
//           </p>
//         </div>
//       </div>

//       {/* Why Choose Us Section */}

//       <div className="p-6 lg:p-12 w-full mb-10">
//         <motion.h2
//           initial={{ opacity: 0, y: -20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-3xl font-bold text-black mb-6"
//         >
//           Why Choose <span className="text-[#f98715]">Adins</span>{" "}
//           International?
//         </motion.h2>

//         <motion.p
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ delay: 0.3, duration: 0.6 }}
//           className="text-md mt-3 text-gray-800 lg:text-lg leading-relaxed mb-8"
//         >
//           At Adins International Pvt. Ltd., we go beyond products—we deliver
//           trust, innovation, and partnership. As a leading manufacturer and
//           exporter of herbal, vegan pet supplements and treats, we are dedicated
//           to helping pets live healthier, happier lives—naturally.
//         </motion.p>

//         <div className="space-y-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {points.map((text, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.1, duration: 0.5 }}
//               className="flex items-start space-x-4"
//             >
//               <div className="min-w-10 min-h-10 w-10 h-10 bg-[#f98715] text-white rounded-full flex items-center justify-center  font-bold shadow-md">
//                 {index + 1}
//               </div>
//               <p className="text-gray-800  md:text-lg">{text}</p>
//             </motion.div>
//           ))}
//         </div>
//         <motion.p
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ delay: 0.3, duration: 0.6 }}
//           className="text-md mt-5 text-gray-800 lg:text-lg leading-relaxed "
//         >
//           Adins International Pvt. Ltd. – Innovating Natural Wellness for Pets &
//           the Planet Let’s work together to bring safe, herbal, and
//           high-performing pet products to markets around the world.
//         </motion.p>
//       </div>

//       {/* Our Mission Section */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 p-4 lg:py-12 lg:px-8">
//         <div className="bg-white shadow-lg rounded-lg p-8 max-w-5xl w-full mb-10">
//           <h2 className="text-4xl font-bold text-gray-700 mb-6">
//             Our Mission
//             <TbTargetArrow className="text-[#f98715] mr-3 text-7xl mt-6" />
//           </h2>
//           <p className="text-gray-700  text-md lg:text-lg leading-relaxed text-justify">
//             At Adins International, we are committed to creating high-quality,
//             science-backed, and vegetarian-friendly pet nutrition products. We
//             aim to empower pet parents with healthier choices while promoting
//             sustainability, animal welfare, and global well-being through
//             innovation, integrity, and care.
//           </p>
//         </div>
//         {/* Our Vision Section */}
//         <div className="bg-white shadow-lg rounded-lg p-8 max-w-5xl w-full mb-10">
//           <h2 className="text-4xl font-bold text-gray-700 mb-6">Our Vision</h2>
//           <GiStairsGoal className="text-7xl text-[#f98715] mt-6" />
//           <p className="text-gray-700  text-md lg:text-lg leading-relaxed mt-5 text-justify">
//             To become a global leader in innovative, ethical, and sustainable
//             solutions that enhance the lives of pets and people—building a
//             future where compassion meets innovation.
//           </p>
//         </div>
//       </div>

//       {/* Choose Adins International Section */}
//       <div className="p-8 lg:px-8 lg:py-8 w-full mb-10">
//         <h2 className="text-3xl font-bold mb-6">
//           Choose <span className="text-[#f98715]">Adins</span> International
//           Pvt. Ltd. -{" "}
//           <span className="text-xl lg:text-3xl italic">
//             Where Nature Meets Pet Care Excellence
//           </span>
//         </h2>
//         <p className="text-gray-700 lg:text-lg leading-relaxed text-justify">
//           Looking for a partner that combines purpose, purity, and performance?
//           Welcome to Adins International Pvt. Ltd., where we don’t just make pet
//           products—we craft natural wellness solutions that inspire trust,
//           loyalty, and love from pet parents worldwide. We believe that pets
//           deserve the same level of care and quality as any member of the
//           family. That’s why we offer an exclusive range of herbal, vegan, and
//           cruelty-free supplements, treats, and foods—formulated with the wisdom
//           of Ayurveda and the precision of modern science.
//         </p>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-10">
//           {brandPoints.map((text, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.1, duration: 0.5 }}
//               className="flex items-start space-x-4"
//             >
//               <div className="min-w-10 min-h-10 w-10 h-10 bg-[#f98715] text-white rounded-full flex items-center justify-center text-base font-bold shadow-md">
//                 {index + 1}
//               </div>
//               <p className="text-gray-800 text-base md:text-lg">{text}</p>
//             </motion.div>
//           ))}
//         </div>

//         <motion.p
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ delay: 0.5, duration: 0.6 }}
//           className="text-md mt-8 text-gray-800 lg:text-lg leading-relaxed"
//         >
//           <strong>Elevate Your Brand with Adins:</strong> Whether you're
//           launching your own line or scaling an established brand, Adins
//           International delivers the quality, integrity, and innovation your
//           customers deserve.
//         </motion.p>
//       </div>

//       <section className="bg-blue-50 p-10 rounded-3xl shadow-xl w-full">
//         <h2 className="text-3xl md:text-4xl font-bold text-blue-800 text-center mb-6 flex items-center justify-center gap-3">
//           <FaHandshake className="text-blue-600 text-3xl" />
//           B2B Partnership Opportunities
//         </h2>
//         <p className="text-gray-800 text-lg leading-relaxed text-center max-w-4xl mx-auto">
//           Adins International proudly offers OEM, private label, and bulk supply
//           services for businesses across the pet care industry. Whether you're a
//           brand, distributor, or retailer, we provide:
//         </p>
//         <ul className="list-disc list-inside text-gray-700 text-base mt-6 max-w-3xl mx-auto space-y-2">
//           <li>Custom Herbal Formulations based on your market needs</li>
//           <li>White Label Solutions with full branding support</li>
//           <li>Flexible MOQ and global shipping options</li>
//           <li>
//             Regulatory Compliance & Certifications for international markets
//           </li>
//           <li>Veterinary-backed product development and R&D support</li>
//         </ul>
//         <p className="text-gray-800 text-lg leading-relaxed mt-6 text-center max-w-3xl mx-auto">
//           Join hands with a trusted Indian manufacturer known for innovation,
//           integrity, and sustainable pet care solutions. Partner with Adins
//           International Pvt. Ltd. to bring safe, plant-powered wellness products
//           to pets worldwide.
//         </p>
//         <p className="text-2xl font-semibold text-center text-blue-700 mt-8">
//           📦 Let’s build a healthier world for pets—together
//         </p>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;

import React from "react";
import { TbTargetArrow } from "react-icons/tb";
import { GiStairsGoal } from "react-icons/gi";
import { motion } from "framer-motion";
import { FaHandshake } from "react-icons/fa";

const points = [
  "Herbal, Plant-Based Formulations",
  "Veterinary-Approved, Research-Backed",
  "Certified Manufacturing Excellence",
  "Full-Service OEM & Private Label Solutions",
  "Global Export Expertise",
  "Sustainable & Ethical Commitment",
  "Dedicated B2B Partnership Support",
];
const brandPoints = [
  "Nature-Powered Formulas: Plant-based, safe, and free from harsh chemicals—because true wellness begins in nature.",
  "Vet-Crafted. Lab-Certified. Pet-Approved.: Backed by veterinarians and tested for safety, efficacy, and flavor.",
  "Your Brand, Our Expertise: Custom formulations, private labeling, and eye-catching packaging that brings your vision to life.",
  "Global-Ready Manufacturing: Export-grade standards with flexible MOQs, fast lead times, and multilingual labeling.",
  "Eco-Conscious from Start to Finish: Sustainable packaging, ethical sourcing, and a strict no-animal-testing policy.",
  "Partners, Not Just Providers: Personalized support, responsive communication, and long-term business commitment.",
];

const AboutUs: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center px-4 sm:px-8 md:px-16">
      {/* About Us Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="bg-[#f98715] p-8 w-full mb-10"
      >
        <h2 className="text-3xl md:text-4xl font-extrabold text-white text-center mb-6">
          About Us
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center space-x-6">
          <div className="w-40 h-40 bg-white rounded-full shadow-lg overflow-hidden mb-4 md:mb-0">
            <img
              src="https://th.bing.com/th/id/OIP.7uBrI-yBrE6iqZpnWDxUgAHaG0?rs=1&pid=ImgDetMain"
              alt="Company Logo"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="text-white text-sm lg:text-lg leading-relaxed md:w-2/3 lg:text-center md:text-left text-justify px-1">
            At <strong>Adins International Pvt. Ltd.</strong>, we believe true
            pet care begins with nature, love, and responsibility. Our mission
            is to craft herbal, plant-based supplements that support your pet’s
            health safely—without chemicals or animal-derived ingredients.
            Rooted in Ayurveda and enhanced by modern science, our vet-approved
            formulas target immunity, digestion, skin, joints, and emotional
            wellness. Every product is 100% vegan, cruelty-free, and ethically
            sourced. We never test on animals and stand for compassionate,
            sustainable care. With Adins, you’re not just choosing
            supplements—you’re joining a movement for conscious, holistic pet
            wellness. Because pets aren’t just companions—they’re family.
          </p>
        </div>
      </motion.div>

      {/* Our Product Range */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="p-8 w-full mb-10"
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-10">
          Our{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#322e88] via-[#f98715] to-purple-600">
            Product
          </span>{" "}
          Range
        </h2>

        <p className="text-md mt-5 text-gray-800 leading-relaxed mb-6 text-justify ">
          Adins International Pvt. Ltd. offers a variety of herbal, vegan, and
          cruelty-free pet wellness products, expertly formulated for dogs and
          cats. Our range includes: <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Herbal Pet
          Supplements: Immunity boosters, digestive enzymes, joint support, skin
          care, and calming drops. <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Pet Treats &
          Snacks: Vegan treats, dental chews, and protein-rich biscuits. <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Complete
          Vegan Pet Food: 100% vegetarian meals and special diets.
          <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Himalayan Yak
          Milk Chews: Long-lasting, preservative-free.
          <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Natural
          Catnip Products: Engaging catnip toys.
          <br />
          <span className="text-[#f98715] text-lg">&#128992;</span>Eco-Friendly
          Cat Litter: Herbal and clay-based options.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Pet Herbal Foods",
              desc: `We offer a comprehensive range of herbal, vegan, and cruelty-free
              pet wellness products designed to support the complete health and
              happiness of dogs and cats. Each product is carefully formulated
              by veterinary experts and crafted using time-tested Ayurvedic
              ingredients combined with modern scientific practices.`,
              bg: "bg-blue-50",
              text: "text-blue-500",
            },
            {
              title: "Packaging Essentials",
              desc: `At Adins International Pvt. Ltd., we provide premium, customizable
              packaging to protect product quality and reflect your brand.
              Choose from stand-up pouches, jars, bottles, sachets, and bulk
              bags in various sizes. Options include BPA-free food-grade layers,
              eco-friendly materials, and resealable closures. Custom branding,
              multilingual labels, and QR codes are available. Packaging is
              designed for 18–24 months of shelf life and optimized for storage
              and shipping with reinforced master cartons.`,
              bg: "bg-yellow-50",
              text: "text-yellow-600",
            },
            {
              title: "Customized Printing",
              desc: `At Adins International Pvt. Ltd., we offer tailored printing and
              labeling services to build your brand identity. Choose from
              digital, flexographic, gravure, or UV printing with waterproof,
              scratch-resistant finishes. Customize labels with your logo,
              product info, QR codes, and multilingual text. We support private
              labeling, unique die cuts, and compliant designs for jars,
              pouches, and bottles. Our in-house team offers design assistance
              and mockups to ensure quality and accuracy. Elevate your packaging
              with premium, market-ready solutions designed to protect and
              promote your product`,
              bg: "bg-purple-50",
              text: "text-purple-600",
            },
          ].map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.2, duration: 0.5 }}
              viewport={{ once: true }}
              className={`${item.bg} p-6 rounded-lg shadow-lg`}
            >
              <h3 className={`text-xl font-semibold ${item.text} mb-4`}>
                {item.title}
              </h3>
              <p className="text-gray-700 text-sm text-justify">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Sustainability Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="p-8 lg:px-8 py-1 w-full mb-10"
      >
        <h2 className="text-3xl font-bold text-green-600 mb-6">
          Sustainability <span className="text-black">at Our Core</span>
        </h2>
        <div className="flex flex-col md:flex-row items-center space-x-6">
          <div className="w-32 h-32 bg-white rounded-full shadow-lg overflow-hidden mb-4 md:mb-0">
            <img
              src="https://norpakltd.com/img/containers/assets/environmental-world.jpg/9e1c97fa4fc8877159ec6c963abd46b3.jpg"
              alt="Sustainability Icon"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="text-gray-700 lg:text-lg text-md px-1 text-justify leading-relaxed w-full lg:text-left md:text-left">
            At Adins International Pvt. Ltd., sustainability is at the heart of
            everything we do. Our 100% plant-based, cruelty-free formulas use
            responsibly sourced herbs and exclude harsh chemicals. We follow
            eco-friendly manufacturing with low waste, energy-efficient, and
            non-toxic processes. Packaging options include biodegradable,
            compostable, and recyclable materials like kraft bags and
            refill-friendly bottles. Our logistics focus on reduced carbon
            footprint through optimized shipping and lightweight packaging. As a
            globally responsible brand, we align with UN Sustainable Development
            Goals and ethical supply chains. Partner with Adins—for high-quality
            pet care that’s better for pets, and better for the planet.
          </p>
        </div>
      </motion.div>

      {/* Why Choose Us Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="p-6 lg:p-12 w-full mb-10"
      >
        <h2 className="text-3xl font-bold text-black mb-6">
          Why Choose <span className="text-[#f98715]">Adins</span>{" "}
          International?
        </h2>

        <p className="text-md mt-3 text-gray-800 lg:text-lg leading-relaxed mb-8">
          At Adins International Pvt. Ltd., we go beyond products—we deliver
          trust, innovation, and partnership. As a leading manufacturer and
          exporter of herbal, vegan pet supplements and treats, we are dedicated
          to helping pets live healthier, happier lives—naturally.
        </p>

        <div className="space-y-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {points.map((text, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
              className="flex items-start space-x-4"
            >
              <div className="min-w-10 min-h-10 w-10 h-10 bg-[#f98715] text-white rounded-full flex items-center justify-center font-bold shadow-md">
                {index + 1}
              </div>
              <p className="text-gray-800 md:text-lg">{text}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Mission & Vision */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4 lg:py-12 lg:px-8"
      >
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-5xl w-full">
          <h2 className="text-4xl font-bold text-gray-700 mb-6 flex items-center">
            Our Mission{" "}
            <TbTargetArrow className="text-[#f98715] ml-2 text-5xl" />
          </h2>
          <p className="text-gray-700 text-md lg:text-lg leading-relaxed text-justify">
            At Adins International, we are committed to creating high-quality,
            science-backed, and vegetarian-friendly pet nutrition products. We
            aim to empower pet parents with healthier choices while promoting
            sustainability, animal welfare, and global well-being through
            innovation, integrity, and care.
          </p>
        </div>
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-5xl w-full">
          <h2 className="text-4xl font-bold text-gray-700 mb-6">Our Vision</h2>
          <GiStairsGoal className="text-7xl text-[#f98715] mb-4" />
          <p className="text-gray-700 text-md lg:text-lg leading-relaxed text-justify">
            To become a global leader in innovative, ethical, and sustainable
            solutions that enhance the lives of pets and people—building a
            future where compassion meets innovation.
          </p>
        </div>
      </motion.div>

      {/* Final CTA */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="p-8 lg:px-8 lg:py-8 w-full mb-10"
      >
        <h2 className="text-3xl font-bold mb-6">
          Choose <span className="text-[#f98715]">Adins</span> International
          Pvt. Ltd. -{" "}
          <span className="text-xl lg:text-3xl italic">
            Where Nature Meets Pet Care Excellence
          </span>
        </h2>
        <p className="text-gray-700 lg:text-lg leading-relaxed text-justify">
          Looking for a partner that combines purpose, purity, and performance?
          Welcome to Adins International Pvt. Ltd., where we don’t just make pet
          products—we craft natural wellness solutions that inspire trust,
          loyalty, and love from pet parents worldwide. We believe that pets
          deserve the same level of care and quality as any member of the
          family. That’s why we offer an exclusive range of herbal, vegan, and
          cruelty-free supplements, treats, and foods—formulated with the wisdom
          of Ayurveda and the precision of modern science.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-10">
          {brandPoints.map((text, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="flex items-start space-x-4"
            >
              <div className="min-w-10 min-h-10 w-10 h-10 bg-[#f98715] text-white rounded-full flex items-center justify-center text-base font-bold shadow-md">
                {index + 1}
              </div>
              <p className="text-gray-800 text-base md:text-lg">{text}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="text-md mt-8 text-gray-800 lg:text-lg leading-relaxed"
        >
          <strong>Elevate Your Brand with Adins:</strong> Whether you're
          launching your own line or scaling an established brand, Adins
          International delivers the quality, integrity, and innovation your
          customers deserve.
        </motion.p>
      </motion.div>
      {/* B2B Partnership Opportunities */}

      {/* <section className="bg-blue-50 p-10 rounded-3xl shadow-xl w-full">
        <h2 className="text-3xl md:text-4xl font-bold text-blue-800 text-center mb-6 flex items-center justify-center gap-3">
          <FaHandshake className="text-blue-600 text-3xl" />
          B2B Partnership Opportunities
        </h2>
        <p className="text-gray-800 text-lg leading-relaxed text-center max-w-4xl mx-auto">
          Adins International proudly offers OEM, private label, and bulk supply
          services for businesses across the pet care industry. Whether you're a
          brand, distributor, or retailer, we provide:
        </p>
        <ul className="list-disc list-inside text-gray-700 text-base mt-6 max-w-3xl mx-auto space-y-2">
          <li>Custom Herbal Formulations based on your market needs</li>
          <li>White Label Solutions with full branding support</li>
          <li>Flexible MOQ and global shipping options</li>
          <li>
            Regulatory Compliance & Certifications for international markets
          </li>
          <li>Veterinary-backed product development and R&D support</li>
        </ul>
        <p className="text-gray-800 text-lg leading-relaxed mt-6 text-center max-w-3xl mx-auto">
          Join hands with a trusted Indian manufacturer known for innovation,
          integrity, and sustainable pet care solutions. Partner with Adins
          International Pvt. Ltd. to bring safe, plant-powered wellness products
          to pets worldwide.
        </p>
        <p className="text-2xl font-semibold text-center text-blue-700 mt-8">
          📦 Let’s build a healthier world for pets—together
        </p>
      </section> */}
    </div>
  );
};

export default AboutUs;
